import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { CreateAppointmentForm } from '../createAppointment/CreateAppointmentForm';

interface ISchedulerCreateAppointmentModalProps {
  open: boolean;
  businessId?: number;
  businessEmployeeId?: number;
  walkIn: boolean;
  onClose: () => void;
  refetch: () => void;
}

export const SchedulerCreateAppointmentModal: React.FC<ISchedulerCreateAppointmentModalProps> = ({
  open,
  businessId,
  businessEmployeeId,
  walkIn,
  onClose,
  refetch,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>
        {walkIn ? 'Novo encaixe' : 'Novo agendamento'}
      </DialogTitle>

      <DialogContent>
        <CreateAppointmentForm
          businessId={businessId}
          businessEmployeeId={businessEmployeeId}
          walkIn={walkIn}
          viaScheduler
          blockBusiness
          blockEmployee={!!businessEmployeeId}
          onSuccess={() => {
            onClose();
            refetch();
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
